import { SelectChangeEvent } from "@mui/material";
import { GlobalVariables } from "config/constant";
import { useSnackBar } from "hooks/useSnackBar";
import { ChangeEvent, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetAllSubCategoriesQuery, useGetSubCategoriesQuery } from "redux/api/category/category";
export default function useSubCategoryList(link?: string, all?: boolean) {
  const { id } = useParams()
  const { displaySuccessSnackBar, displayErrorApiSnackBar } = useSnackBar();
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(
    link === "2" || all ? 99999 : GlobalVariables.DefaultPerPage
  );
  console.log(link, 'retard')
  useEffect(() => {
    setPerPage(link === "2" || all ? 99999 : GlobalVariables.DefaultPerPage);
  }, [link]);

  console.log(perPage)
  const [orderBy, setOrderBy] = useState<string>("created_at");
  const [orderDir, setOrderDir] = useState<"" | "asc" | "desc">("desc");
  const [isArchived, setIsArchived] = useState<boolean>(false);

  const {
    data: subCategoryData,
    error,
    isLoading,
    refetch,
  } = useGetAllSubCategoriesQuery({
    paginator: {
      search: search,
      page: page,
      perPage: perPage,
      orderBy: orderBy,
      orderDir: orderDir,
    }, id: id ? id : "0", withTrashed: isArchived ? 2 : undefined
  })


  if (error) {
    displayErrorApiSnackBar(error);
  }

  const onPageChange = (page: number) => {
    setPage(page);
    setTimeout(() => {
      refetch();
    }, 300);
  };

  const onSearchChange = (e: ChangeEvent<HTMLInputElement> | string) => {
    setPage(1);
    if (typeof e === "string") {
      setSearch(e);
    } else {
      setSearch(e.target.value);
    }
  };

  const onPerPageChange = (event: SelectChangeEvent<number>) => {
    setPerPage(parseInt(String(event.target.value), 10));
    setPage(1);
  };

  const onOrderChange = (field: string) => () => {
    const order_dir =
      orderBy === field
        ? orderDir === "asc"
          ? "desc"
          : orderDir === "desc"
            ? ""
            : "asc"
        : "asc";
    setOrderDir(order_dir);
    setOrderBy(order_dir === "" ? "" : field);
  };

  return {
    onSearchChange,
    onPageChange,
    onPerPageChange,
    onOrderChange,
    subCategoryData,
    isLoading,
    search,
    orderBy,
    orderDir,
    page,
    perPage,
    refetch,
    setPerPage,
    isArchived,
    setIsArchived
  };
}
